import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { DetailedChangeset } from 'ember-changeset/types';
import type FlowModel from 'garaje/models/flow';
import type StateService from 'garaje/services/state';
import { alias } from 'macro-decorators';

interface FlowsSectionsGeneralComponentSignature {
  Args: {
    changeset: DetailedChangeset<FlowModel>;
  };
}

export default class FlowsSectionsGeneralComponent extends Component<FlowsSectionsGeneralComponentSignature> {
  @service declare state: StateService;

  @alias('state.currentLocation') currentLocation!: StateService['currentLocation'];

  @tracked showModalTranslations = false;
  @tracked showModalDelete = false;

  @tracked changeset;

  constructor(owner: unknown, args: FlowsSectionsGeneralComponentSignature['Args']) {
    super(owner, args);
    this.changeset = this.args.changeset;
  }

  @action
  handleChangeName(name: string): void {
    this.changeset.name = name;
  }

  @action
  handleChangeDescription(description: string): void {
    this.changeset.description = description;
  }
}
